<template>
  <div
    class="border-ontick-steel-300 dark:bg-ontick-graphite-500 flex flex-col gap-4 rounded-lg border-2 p-4 transition-all dark:border-0"
  >
    <p class="text-lg font-bold">Regras de execução</p>
    <div class="flex w-full items-center gap-4">
      <ontick-editable-select-component
        v-if="data.symbol1 && data.symbol2"
        class="w-full"
        :options="options"
        :value="data.method"
        :acceptInput="false"
        :disabled="isEditing || isPublicOrder"
        label="Método"
        name="method"
        @input="
          setData({
            ...$event,
            value: $event.value,
          })
        "
      />
      <div
        v-else
        class="w-full cursor-not-allowed"
        content="Selecione um par de ativos primeiro"
        v-tippy="{ arrow: true, theme: 'red' }"
      >
        <ontick-editable-select-component
          disabled
          class="w-full"
          :options="options"
          :value="data.method"
          :acceptInput="false"
          label="Método"
          name="method"
          @input="
            setData({
              ...$event,
              value: $event.value,
            })
          "
        />
      </div>
      <template v-if="data.method">
        <div
          class="flex w-full flex-col gap-1"
          v-if="['Fator', 'Diferença'].includes(data.method)"
        >
          <label for="entryFactor" class="text-sm">
            {{ data.method }} de entrada
          </label>
          <input
            type="number"
            class="border-ontick-steel-300 dark:bg-ontick-carbon-500 disabled:bg-ontick-steel-500 h-10 w-full rounded border-2 px-2 text-sm shadow disabled:cursor-not-allowed disabled:border dark:border-0"
            :class="
              factorWarning
                ? 'ring-ontick-orange-600 focus:ring-ontick-orange-600 border ring-1 focus:outline-none focus:ring'
                : ''
            "
            name="entryFactor"
            step="0.000001"
            :value="data.entryFactor"
            @input="
              setData({
                prop: 'entryFactor',
                value: parseFloat($event.target.value) || 0,
              })
            "
            :disabled="isPublicOrder || isRunning"
          />
          <span class="text-ontick-orange-600 text-xs" v-if="factorWarning">
            {{ factorWarning }}
          </span>
        </div>
        <template v-else-if="['Função linear'].includes(data.method)">
          <div class="flex w-full flex-col gap-1">
            <label for="entryFactor" class="text-sm"> Intercepto </label>
            <!-- :class="
                factorWarning
                  ? 'ring-ontick-orange-600 focus:ring-ontick-orange-600 border ring-1 focus:outline-none focus:ring'
                  : ''
              " -->
            <input
              type="number"
              class="bg-ontick-carbon-500 disabled:bg-ontick-steel-500 h-10 w-full rounded border-0 px-2 text-sm shadow disabled:cursor-not-allowed disabled:border"
              name="entryFactor"
              step="0.000001"
              :value="data.intercept"
              @input="
                setData({
                  prop: 'intercept',
                  value: parseFloat($event.target.value) || 0,
                })
              "
              :disabled="isPublicOrder || isRunning"
            />
            <!-- <span class="text-ontick-orange-600 text-xs" v-if="factorWarning">
              {{ factorWarning }}
            </span> -->
          </div>
          <div class="flex w-full flex-col gap-1">
            <label for="entryFactor" class="text-sm">
              Coeficiente angular
            </label>
            <!-- :class="
                factorWarning
                  ? 'ring-ontick-orange-600 focus:ring-ontick-orange-600 border ring-1 focus:outline-none focus:ring'
                  : ''
              " -->
            <input
              type="number"
              class="bg-ontick-carbon-500 disabled:bg-ontick-steel-500 h-10 w-full rounded border-0 px-2 text-sm shadow disabled:cursor-not-allowed disabled:border"
              name="entryFactor"
              step="0.000001"
              :value="data.slope"
              @input="
                setData({
                  prop: 'slope',
                  value: parseFloat($event.target.value) || 0,
                })
              "
              :disabled="isPublicOrder || isRunning"
            />
            <!-- <span class="text-ontick-orange-600 text-xs" v-if="factorWarning">
              {{ factorWarning }}
            </span> -->
          </div>
        </template>
      </template>
    </div>
    <div class="flex flex-col gap-4">
      <div class="divide-ontick-steel-500 divide-y-2">
        <template v-if="data.method">
          <div class="flex w-full items-center gap-4">
            <div
              v-if="data.method !== 'Função linear'"
              class="flex w-full translate-y-3 transform items-center gap-2"
            >
              <ontick-switch-component
                :active="data.advancedParams"
                @switch="
                  setData({
                    prop: 'advancedParams',
                    value: !data.advancedParams,
                  })
                "
                :disabled="isEditing || isRunning"
              />
              <span class="text-xs">Parâmetros avançados</span>
            </div>

            <div
              class="flex w-full flex-col gap-1"
              v-if="['Fator', 'Diferença'].includes(data.method)"
            >
              <label for="entryFactor" class="text-sm">
                {{ data.method }} atual
              </label>
              <div class="flex items-center gap-2">
                <input
                  type="text"
                  class="input"
                  :value="data.currentFactor"
                  disabled
                />
                <button class="h-full px-2" @click="checkSymbols">
                  <div class="scale-75 transform">
                    <i
                      v-html="$icons.double_refresh"
                      class="text-ontick-blue-600"
                    ></i>
                    <span class="sr-only">Atualizar</span>
                  </div>
                </button>
              </div>
            </div>
            <div
              v-else-if="['Função linear'].includes(data.method)"
              class="flex w-full items-center gap-4"
            >
              <div class="flex w-full flex-col gap-1">
                <label for="entryFactor" class="text-sm"> Resíduo atual</label>
                <div class="relative flex items-center gap-2">
                  <input
                    type="text"
                    class="input"
                    :value="data.residue"
                    disabled
                  />
                  <button
                    class="absolute top-1/2 right-0 h-full -translate-y-1/2 transform px-2"
                    @click="checkSymbols"
                  >
                    <div class="scale-75 transform">
                      <i
                        v-html="$icons.double_refresh"
                        class="text-ontick-blue-600"
                      ></i>
                      <span class="sr-only">Atualizar</span>
                    </div>
                  </button>
                </div>
              </div>
              <div class="flex w-full flex-col gap-1">
                <label for="entryFactor" class="text-sm">
                  Resíduo de entrada
                </label>
                <div class="flex items-center gap-2">
                  <input
                    type="number"
                    class="bg-ontick-carbon-500 disabled:bg-ontick-steel-500 h-10 w-full rounded border-0 px-2 text-sm shadow disabled:cursor-not-allowed disabled:border"
                    name="entryFactor"
                    step="0.000001"
                    :value="data.entryFactor"
                    @input="
                      setData({
                        prop: 'entryFactor',
                        value: parseFloat($event.target.value) || 0,
                      })
                    "
                    :disabled="isPublicOrder || isRunning"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="flex items-center pb-4">
        <div
          v-if="data.method === 'Função linear'"
          class="flex w-full translate-y-3 transform items-center gap-2"
        >
          <ontick-switch-component
            :active="data.advancedParams"
            @switch="
              setData({
                prop: 'advancedParams',
                value: !data.advancedParams,
              })
            "
          />
          <span class="text-xs">Parâmetros avançados</span>
        </div>
      </div>
      <transition name="dropdown">
        <div class="gap-4" v-if="data.advancedParams">
          <div class="flex items-center gap-4">
            <div class="flex w-full flex-col gap-1" v-if="data.method">
              <label for="TPFactor" class="text-sm">
                TP ({{ factorName }})
              </label>
              <div class="relative">
                <input
                  type="number"
                  step="0.000001"
                  class="input"
                  name="TPFactor"
                  :value="data.TPFactor"
                  @input="
                    setData({
                      prop: 'TPFactor',
                      value: parseFloat($event.target.value) || 0,
                    })
                  "
                  :disabled="isPublicOrder || isRunning"
                />
                <variable-unit-type-input-component
                  :value="data.tp_sl_calc_type"
                  @input="
                    setData({
                      prop: 'tp_sl_calc_type',
                      value: $event,
                    })
                  "
                  class="absolute right-2 top-1/2 -translate-y-1/2 transform"
                  :method="data.method"
                  :disabled="
                    !!this.$route.params.alg_ord_id ||
                    isPublicOrder ||
                    isRunning
                  "
                />
              </div>
            </div>
            <div class="flex w-full flex-col gap-1" v-if="data.method">
              <label for="SLFactor" class="text-sm">
                SL ({{ factorName }})</label
              >
              <div class="relative">
                <input
                  type="number"
                  step="0.000001"
                  class="input"
                  name="SLFactor"
                  :value="data.SLFactor"
                  @input="
                    setData({
                      prop: 'SLFactor',
                      value: parseFloat($event.target.value) || 0,
                    })
                  "
                  :disabled="isPublicOrder || isRunning"
                />
                <variable-unit-type-input-component
                  :value="data.tp_sl_calc_type"
                  @input="
                    setData({
                      prop: 'tp_sl_calc_type',
                      value: $event,
                    })
                  "
                  class="absolute right-2 top-1/2 -translate-y-1/2 transform"
                  :method="data.method"
                  :disabled="
                    !!this.$route.params.alg_ord_id ||
                    isPublicOrder ||
                    isRunning
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import ontickEditableSelectComponent from "../../../shared/components/basic/ontick-editable-select.component.vue";
import { mapActions, mapGetters } from "vuex";
import OntickSwitchComponent from "../../../shared/components/basic/ontick-switch.component.vue";
import VariableUnitTypeInputComponent from "./variable-unit-type-input.component.vue";
export default {
  components: {
    ontickEditableSelectComponent,
    OntickSwitchComponent,
    VariableUnitTypeInputComponent,
  },

  props: {
    options: { type: Array },
    isPublicOrder: {
      type: Boolean,
    },
    editInfo: {
      type: Object,
    },
  },

  data() {
    return {
      advancedParamsIsActive: false,
      factorInfo: {},
    };
  },

  computed: {
    ...mapGetters({ data: "longShort/getData" }),
    isRunning() {
      if (this.editInfo?.alg_ord_state) {
        return !["NEW", "FILLED", "STOPPED"].includes(
          this.editInfo.alg_ord_state
        );
      } else {
        return false;
      }
    },
    isEditing() {
      return !!this.$route.params.alg_ord_id;
    },
    factorWarning() {
      if (
        (this.data.operationType === "Compra" &&
          this.data.entryFactor > this.data.currentFactor) ||
        (this.data.operationType === "Venda" &&
          this.data.entryFactor < this.data.currentFactor)
      ) {
        return "Essa operação poderá ser executada instantaneamente";
      } else {
        return null;
      }
    },
    factorName() {
      switch (this.data.method) {
        case "Função linear":
          switch (this.data.tp_sl_calc_type) {
            case "factor":
              return "Resíduo";
            case "percent":
              return "Percentual";
          }
        case "Fator":
          switch (this.data.tp_sl_calc_type) {
            case "factor":
              return "Fator";
            case "percent":
              return "Percentual";
          }
        case "Diferença":
          switch (this.data.tp_sl_calc_type) {
            case "factor":
              return "Diferença";
            case "percent":
              return "Percentual";
          }
      }
    },
    dataToWatch() {
      return Object.assign({}, this.data);
    },
  },

  methods: {
    ...mapActions({
      setData: "longShort/setData",
      checkSymbols: "longShort/checkSymbols",
    }),
    updateFactor() {
      return new Promise((resolve, reject) => {
        this.checkSymbols()
          .then((res) => {
            this.factorInfo = res;

            this.setData({
              prop: "symbol1MinVolume",
              value: res.symbol_1_info.symbol_min_volume,
            });
            this.setData({
              prop: "symbol2MinVolume",
              value: res.symbol_2_info.symbol_min_volume,
            });
            this.setData({
              prop: "symbol1MaxVolume",
              value: res.symbol_1_info.symbol_min_volume,
            });
            this.setData({
              prop: "symbol2MaxVolume",
              value: res.symbol_2_info.symbol_min_volume,
            });

            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },

  watch: {
    dataToWatch: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.method != oldVal.method) {
          this.updateFactor();
        }
        if (
          newVal.method === "Função linear" &&
          newVal.intercept &&
          newVal.slope
        ) {
          const differenceArray = [
            newVal.intercept === oldVal.intercept,
            newVal.slope === oldVal.slope,
          ];
          if (differenceArray.some((item) => item === false)) {
            this.updateFactor().then(({ symbol_1_info, symbol_2_info }) => {
              const y = symbol_1_info.symbol_1_close;
              const x = symbol_2_info.symbol_2_close;
              const a = newVal.slope;
              const b = newVal.intercept;
              const residue = y - (a * x + b);
              this.setData({
                prop: "residue",
                value: Number(residue.toFixed(6)),
              });
            });
          }
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.input {
  @apply border-ontick-steel-300 dark:bg-ontick-carbon-500 dark:disabled:bg-ontick-steel-500 h-10 w-full rounded border-2 px-2 text-sm shadow disabled:cursor-not-allowed disabled:border disabled:bg-gray-400 dark:border-0;
}
.dropdown {
  &-enter-active,
  &-leave-active {
    @apply transition-all;
  }
  &-enter, &-leave-to /* .fade-leave-active below version 2.1.8 */ {
    @apply -translate-y-1/2 scale-y-0 opacity-0;
  }
}
</style>
